<template>
	<section class="newsletter-section">
		<div class="row">
			<div class="columns column12 align-center">
				<h3>{{ header }}</h3>
				<p>{{ content }}</p>
			</div>
			<div class="columns column12">
				<form class="newsletter">
					<input type="text" :placeholder="$t('formEmail')" />
					<input type="submit" class="button" :value="button" />
				</form>
			</div>
		</div>
	</section>
</template>

<script setup>
defineProps({
	header: { type: String, default: '' },
	content: { type: String, default: '' },
	button: { type: String, default: '' },
});
</script>

<style lang="scss" scoped>
section {
	background: var(--newsletter-background-color);
	color: var(--primary-text-color);
	padding: 40px 20px;
	max-width: 840px;
	width: 90%;
	margin: -135px auto;
	position: relative;

	::placeholder {
		color: var(--primary-text-color);
	}

	h3 {
		color: var(--primary-text-color);
	}

	.newsletter {
		width: 100%;
		max-width: 640px;
		margin: 0 auto;
		text-align: center;
	}

	input {
		background: none;
		color: var(--primary-text-color);
		padding: 15px;
		border: 1px solid var(--primary-text-color);
		max-width: 60%;
		width: 300px;
		appearance: none;
		outline: none;
		margin: 5px;

		&.button {
			border: none;
			color: #fff;
			line-height: 20px;
			background: var(--primary-color);
			cursor: pointer;
			width: auto;
			padding: 19px 25px 18px;

			&:hover {
				background: var(--primary-color-hover);
			}
		}
	}
}

@media (max-width: 900px) {
	section input {
		margin: 0 0 10px;
	}
}
</style>
